module.exports = __webpack_public_path__ + "static/img/login-img.098b8f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-img.png
// module id = h+gl
// module chunks = 1